module.exports = __webpack_public_path__ + "static/img/train-img.afe9fbb2.png";